(function () {
  "use strict";
  var root = document.querySelector(".sy-acc");
  if (!root) return;

  /* Ancres internes : defilement doux (comportement d'origine) */
  root.querySelectorAll('a[href^="#sy-acc-"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").slice(1);
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  /* Bande photos clients : defilement a la souris (comportement d'origine) */
  root.querySelectorAll(".sy-acc-clients__strip").forEach(function (strip) {
    var isDown = false, startX = 0, startScroll = 0;
    strip.addEventListener("pointerdown", function (e) {
      isDown = true;
      startX = e.pageX;
      startScroll = strip.scrollLeft;
      strip.style.cursor = "grabbing";
    });
    window.addEventListener("pointerup", function () {
      isDown = false;
      strip.style.cursor = "";
    });
    strip.addEventListener("pointermove", function (e) {
      if (isDown) strip.scrollLeft = startScroll - (e.pageX - startX);
    });
  });

  /* ------------------------------------------------------------------
     Apercu rapide des packs
     Le bouton « Voir le pack » ouvre une fenetre avec la fiche du pack.
     Le lien reste un vrai lien : sans JS, ou en clic milieu / nouvel
     onglet, il mene toujours a la fiche produit.
     ------------------------------------------------------------------ */

  var CSS =
    '.sy-qv{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px}' +
    '.sy-qv[hidden]{display:none}' +
    '.sy-qv__back{position:absolute;inset:0;background:rgba(13,13,13,.62);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}' +
    '.sy-qv__box{position:relative;background:#fff;border-radius:16px;max-width:860px;width:100%;max-height:90vh;overflow:auto;box-shadow:0 24px 60px rgba(0,0,0,.28)}' +
    '.sy-qv__close{position:absolute;top:10px;right:10px;z-index:2;width:36px;height:36px;border:0;border-radius:50%;background:#f4f5f7;color:#171717;font-size:20px;line-height:1;cursor:pointer}' +
    '.sy-qv__close:hover{background:#e5e7eb}' +
    '.sy-qv__grid{display:grid;grid-template-columns:1fr 1fr;gap:0}' +
    '.sy-qv__media{background:#f4f5f7;aspect-ratio:16/9;display:grid;place-items:center;overflow:hidden}' +
    '.sy-qv__media img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.sy-qv__body{padding:clamp(18px,3vw,28px)}' +
    '.sy-qv__kicker{margin:0 0 6px;font-size:12px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#00875A}' +
    '.sy-qv__title{margin:0 0 10px;font-size:clamp(1.25rem,2.2vw,1.6rem);font-weight:800;line-height:1.15;color:#171717}' +
    '.sy-qv__desc{margin:0 0 16px;font-size:.95rem;line-height:1.6;color:#4b5563}' +
    '.sy-qv__desc p{margin:0 0 8px}' +
    '.sy-qv__price{display:flex;align-items:baseline;gap:10px;margin:0 0 18px}' +
    '.sy-qv__now{font-size:1.6rem;font-weight:800;color:#00875A}' +
    '.sy-qv__was{font-size:1rem;color:#9ca3af;text-decoration:line-through}' +
    '.sy-qv__add{display:inline-flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 20px;border:0;border-radius:999px;background:#00875A;color:#fff;font-weight:700;font-size:.95rem;cursor:pointer}' +
    '.sy-qv__add:hover{background:#00734B}' +
    '.sy-qv__add[disabled]{opacity:.6;cursor:default}' +
    '.sy-qv__links{display:flex;flex-wrap:wrap;gap:14px;margin:12px 0 0}' +
    '.sy-qv__links a{font-size:.85rem;font-weight:700;color:#171717;text-decoration:underline}' +
    '.sy-qv__msg{margin:10px 0 0;font-size:.85rem;color:#b91c1c}' +
    '@media(max-width:700px){.sy-qv__grid{grid-template-columns:1fr}}';

  function euro(cents) {
    if (typeof cents !== "number") return "";
    return (cents / 100).toFixed(2).replace(".", ",").replace(/,00$/, "") + " €";
  }

  var modal = null, lastFocus = null;
  var box, gridEl, mediaEl, kickerEl, titleEl, descEl, nowEl, wasEl, addBtn, msgEl, linkEl;
  var current = null;

  function build() {
    var s = document.createElement("style");
    s.textContent = CSS;
    document.head.appendChild(s);

    modal = document.createElement("div");
    modal.className = "sy-qv";
    modal.hidden = true;
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-label", "Aperçu du pack");
    modal.innerHTML =
      '<div class="sy-qv__back" data-close></div>' +
      '<div class="sy-qv__box">' +
      '<button class="sy-qv__close" type="button" data-close aria-label="Fermer">&times;</button>' +
      '<div class="sy-qv__grid">' +
      '<div class="sy-qv__media"></div>' +
      '<div class="sy-qv__body">' +
      '<p class="sy-qv__kicker"></p>' +
      '<h2 class="sy-qv__title"></h2>' +
      '<div class="sy-qv__desc"></div>' +
      '<p class="sy-qv__price"><span class="sy-qv__now"></span><span class="sy-qv__was"></span></p>' +
      '<button class="sy-qv__add" type="button">Ajouter au panier</button>' +
      '<p class="sy-qv__msg" hidden></p>' +
      '<p class="sy-qv__links"><a class="sy-qv__full" href="#">Voir la fiche complète</a></p>' +
      "</div></div></div>";
    document.body.appendChild(modal);

    box = modal.querySelector(".sy-qv__box");
    gridEl = modal.querySelector(".sy-qv__grid");
    mediaEl = modal.querySelector(".sy-qv__media");
    kickerEl = modal.querySelector(".sy-qv__kicker");
    titleEl = modal.querySelector(".sy-qv__title");
    descEl = modal.querySelector(".sy-qv__desc");
    nowEl = modal.querySelector(".sy-qv__now");
    wasEl = modal.querySelector(".sy-qv__was");
    addBtn = modal.querySelector(".sy-qv__add");
    msgEl = modal.querySelector(".sy-qv__msg");
    linkEl = modal.querySelector(".sy-qv__full");

    modal.addEventListener("click", function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute("data-close")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal && !modal.hidden) close();
    });
    addBtn.addEventListener("click", addToCart);
  }

  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    box.setAttribute("tabindex", "-1");
    box.focus();
  }

  function close() {
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function fill(p, href) {
    current = p;
    var avail = (p.variants || []).filter(function (x) { return x.available; });
    var v = avail[0] || (p.variants || [])[0];
    current.variantId = v && v.id;

    /* La colonne image est pilotee en style inline : une feuille tierce
       force display:none sur les blocs vides, et l'inline la court-circuite.
       Pas de photo sur le produit => fenetre sur une seule colonne. */
    mediaEl.innerHTML = "";
    if (p.featured_image) {
      var img = document.createElement("img");
      img.src = p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=800";
      img.alt = p.title || "";
      img.loading = "lazy";
      mediaEl.appendChild(img);
      mediaEl.style.display = "grid";
      gridEl.style.gridTemplateColumns = "";
    } else {
      mediaEl.style.display = "none";
      gridEl.style.gridTemplateColumns = "1fr";
    }

    kickerEl.textContent = "Pack";
    titleEl.textContent = p.title || "";
    descEl.innerHTML = p.description || "";
    nowEl.textContent = euro(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      wasEl.textContent = euro(p.compare_at_price);
      wasEl.hidden = false;
    } else {
      wasEl.textContent = "";
      wasEl.hidden = true;
    }
    linkEl.setAttribute("href", href);
    linkEl.textContent = "Voir la fiche complète";

    msgEl.hidden = true;
    msgEl.textContent = "";
    addBtn.disabled = !(v && v.available);
    addBtn.textContent = v && v.available ? "Ajouter au panier" : "Indisponible";
  }

  function addToCart() {
    if (!current || !current.variantId) return;
    addBtn.disabled = true;
    addBtn.textContent = "Ajout…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: current.variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart");
        return r.json();
      })
      .then(function () {
        addBtn.textContent = "Ajouté au panier ✓";
        linkEl.textContent = "Voir le panier";
        linkEl.setAttribute("href", "/cart");
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = "Ajouter au panier";
        msgEl.textContent = "Ajout impossible pour le moment. Ouvrez la fiche complète.";
        msgEl.hidden = false;
      });
  }

  root.querySelectorAll(".sy-acc-pack__cta").forEach(function (a) {
    var href = a.getAttribute("href") || "";
    var m = href.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    a.addEventListener("click", function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      if (!modal) build();
      fetch("/products/" + m[1] + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) throw new Error("product");
          return r.json();
        })
        .then(function (p) {
          fill(p, href);
          open();
        })
        .catch(function () {
          window.location.href = href;
        });
    });
  });
})();